import React, { FC, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { AuthSocial, AuthTerms } from '../Components';
import { Logo } from '../../../../shared';
import { LoginForm } from './LoginForm';

import routes from '../../../../../routes';

export const Login: FC = (): JSX.Element => {
  useEffect((): void => {
    document.title = `Scrnli - Sign In`;
  }, []);

  return (
    <div className="auth-page">
      <Logo />
      <h4 className="auth-page__title">Sign In</h4>
      <div className="auth-page-suggestion">
        <span>New user?</span>&nbsp;
        <Link className="link" to={ routes.registration }>
          Create an account
        </Link>
      </div>
      <AuthSocial />
      <LoginForm />
      <AuthTerms />
    </div>
  );
};

export default Login;
